<div class="status-card dis-flex">
    <div class="content-wrapper">
        <div class="count">
            <h1 class="font-medium m-b-0" [ngStyle]="{'color': iconColor}">{{ count }}</h1>
        </div>
        <div class="title">
            <p class="b2">{{ title }}</p>
        </div>
    </div>
    <div class="icon" [ngStyle]="{'background-color': iconBoxColor}">
        <ng-icon [name]="iconName" [color]="iconColor"></ng-icon>
    </div>
</div>